export const AUTH_INTERVAL_TIME_CHECK = 60;
